module.exports = __webpack_public_path__ + "static/media/11.3327b82c.jpeg";